export const RISK_CATEGORY_TAGS = [
  {
    label: "Daily",
    id: "330cb564-8398-4364-99df-260ff63f248e",
  },
  {
    label: "Weekly",
    id: "9b08f9fa-f14d-4034-aabb-3f9d92822d7c",
  },
  {
    label: "Monthly",
    id: "43c13d53-cbf9-4e20-b251-4039442d7642",
  },
];
